import { lazy } from 'react';

const LoadableNavPhase1AppLayout = lazy(
  () => import(/* webpackChunkName: "4-page-navphase1-applayout" */ '../VivaEngage/Template')
);

export default LoadableNavPhase1AppLayout;
